import React from 'react';

import { API_METHOD } from 'config';

import { Polling } from '_core/hooks/useRequest';


const promises = {};


export const getAgg = (method) => {
  const promise = promises[method];
  
  if (promise)
    return promise;
  
  return promises[method] = new Promise((resolve, reject) => {
    Polling.queue(method, {})
      .then(resolve)
      .catch(reject);
  });
};

export const getSettings = () => getAgg(API_METHOD.SETTINGS);

export const getSetting = async (name, def) => {
  try {
    const result = (await getSettings())[name];
    
    if (typeof result === 'undefined' || result === null)
      return typeof def === 'undefined' ? result : def;
    
    return result;
  } catch (e) {
    if (typeof def === 'undefined')
      throw e;
    
    return def;
  }
};

export const useAgg = (method, initValue, errorValue) => {
  const [result, setResult] = React.useState(initValue);
  
  React.useEffect(() => {
    getAgg(method)
      .then(setResult)
      .catch((e) => setResult(errorValue));
  }, []);
  
  return result;
};
